import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ccw",
  "use": "icon-ccw-usage",
  "viewBox": "0 0 52 46",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 52 46\" id=\"icon-ccw\"><g><path d=\"M33.219 1.5l14.85 25.978h-12.87L20.348 1.5h12.87z\" stroke=\"#000\" stroke-width=\"3\" /><path d=\"M0 31.394L15.605 3.626l8.399 14.484L8.16 45.883zM43.692 45.883H12.243l8.16-14.489h31.454z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol